// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-o_eT","advertDetailService__price":"c-o_eU"};